<ng-container *ngIf="isBrowser">
    <ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title()}}</span>
        <ng-container *ngTemplateOutlet="airports?.length > 0  ? aslist : fromextern"></ng-container>
    </div>
</ng-template>


<ng-template #fromextern>
    <div class="tmp-section-body">
        <button class="tmp-f-selection-btn" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
            (click)="openModalMobile($event)" matRipple>
            <div class="tmp-btn-sub">
                <!-- <mat-icon class="tmp-f-selection-btn-icon rotate mr05">flight</mat-icon> -->
                <svg class="rotate mr05" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
                    width="24px" fill="#000000">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
                </svg>
                <span multilang>{{zielText}}</span>
            </div>
            <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
        </button>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>



<ng-template #homemodeMobile>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title()}}</span>
        <ng-container *ngTemplateOutlet="airports?.length > 0  ? aslist : fromextern"></ng-container>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{title()}}</span>
        <div class="tmp-section-body">
            <button class="tmp-f-selection-btn" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
                (click)="openModal($event)" matRipple>
                <div class="tmp-btn-sub">
                    <!-- <mat-icon class="tmp-f-selection-btn-icon rotate mr05">flight</mat-icon> -->
                    <svg class="rotate mr05" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
                        width="24px" fill="#000000">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
                    </svg>
                    <span multilang>{{zielText}}</span>
                </div>
                <mat-icon class="tmp-f-selection-btn-icon">arrow_drop_down</mat-icon>
            </button>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="sendSelect()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>


<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" multilang deeplMode='placeholder' placeholder="Flughafen hinzufügen"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="sendSelect()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" multilang deeplMode='placeholder' placeholder="Flughafen hinzufügen"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <ng-container *ngIf="selectedList?.length > 0">
            <div class="selected-wrapper">
                <button class="selected-item-alle" (click)="removeAllSelected()">
                    <span multilang>{{'Alles löschen'}}</span>
                </button>
                <ng-container *ngFor="let item of selectedList; let k = index">
                    <div class="selected-item">
                        <span multilang>{{item.name}} <span multilang
                                class="second-item-line">{{item.code}}</span></span>
                        <button (click)="removeFromSelected(k)">
                            <mat-icon class="clearbtn">clear</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngFor="let item of (searchObj | async)">
            <ng-container *ngIf="isNotInlist(item)">
                <button class="item-wrapper" (click)="selectValue(item)">
                    <div class="item-body">
                        <span multilang class="first-item-line">{{item.name}} <span multilang
                                class="second-item-line">{{item.code}}</span></span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" multilang (click)="sendSelect()">{{'ÜBERNEHMEN'}}</button>
    </div>
</ng-template>


<ng-template #aslist>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of sortArray(airports)| slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selected(item)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedListOnlyCode.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span multilang class="tour-item-name">{{item.name}}</span>
                    <span multilang class="bestprcit">{{'ab'}} {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="airports.length > 5">
            <ng-container *ngIf="(slicenbr < airports.length) else less">
                <button class="showallbtn" (click)="showMore(airports.length)" matRipple>
                    <span multilang>{{'alle'}} {{airports.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>